import moment from 'moment';
import { dateFormat } from './util';

const today = [moment(moment(), dateFormat), moment(moment(), dateFormat)];
const thisMonth = [
  moment(moment().startOf('month'), dateFormat),
  moment(moment(), dateFormat),
];
const lastMonth = [
  moment(moment().subtract(1, 'month').startOf('month'), dateFormat),
  moment(moment().subtract(1, 'month').endOf('month'), dateFormat),
];
const last90 = [
  moment(moment().subtract(90, 'days'), dateFormat),
  moment(moment(), dateFormat),
];
const thisYear = [
  moment(moment().startOf('year'), dateFormat),
  moment(moment(), dateFormat),
];

const coreData = true;

const all = [];

export default {
  today,
  thisMonth,
  lastMonth,
  last90,
  thisYear,
  coreData,
  all,
};
